import { Form } from "react-bootstrap";
import styles from '../pa_checklist.module.scss';
import { isNullish } from "../../../../utils/misc_utils";

const MedidasForm = ({
  formularios,
  setFormularios,
  grupoSelecionado,
  tamanhoSelecionado,
  possuiPecaPiloto,
  referenciaSelecionada,
  onToggleSwitch,
  onAtualizarPiloto,
  titulo = "Peça Principal"
}) => {

  const handleEntreTolerancia = (ao, mft, t) => {
    return parseFloat(ao) >= parseFloat(mft) - parseFloat(t) && parseFloat(ao) <= parseFloat(mft) + parseFloat(t);
  }

  const handleCalculoAceitavel = (index) => {
    const { medicao_ft, amostra_obrigatoria, amostra_opcional, tolerancia } = formularios[index];
    if (isNullish(amostra_obrigatoria)) return false;
    if (handleEntreTolerancia(amostra_obrigatoria, medicao_ft, tolerancia)) return true;
    if (handleEntreTolerancia(amostra_opcional, medicao_ft, tolerancia)) return true;
    return false;
  }

  const handleValueMask = (index, field, value) => {
    const digitsOnly = value.replace(/\D/g, '');
    const paddedValue = digitsOnly.padStart(3, '0');
    const formattedValue = `${paddedValue.slice(0, -2)}.${paddedValue.slice(-2)}`;

    const updatedFormularios = [...formularios];
    updatedFormularios[index][field] = formattedValue.replace(/^0+(?=\d\.)/, '');
    updatedFormularios[index].medida_aceitavel = handleCalculoAceitavel(index);

    setFormularios(updatedFormularios);
  }

  return (
    <>
      <div style={{ marginBottom: '-12px', fontWeight: '500' }}>{titulo}</div>
      <div className={styles.medida_table_wrapper}>
        <div className={styles.medida_table_header}>
          <div className={styles.row_cell} style={{ width: '10%' }}></div>
          <div
            className={styles.row_cell}
            style={{ width: '5%', display: grupoSelecionado.value === 5 ? 'flex' : 'none' }}
          >
            Cod.
          </div>
          <div
            className={styles.row_cell}
            style={{ width: grupoSelecionado.value === 5 ? '17%' : '22.5%' }}
          >
            Parte
          </div>
          <div
            className={styles.row_cell}
            style={{ width: grupoSelecionado.value === 5 ? '17%' : '22.5%' }}
          >
            Piloto
          </div>
          <div
            className={styles.row_cell}
            style={{ width: grupoSelecionado.value === 5 ? '17%' : '22.5%' }}
          >
            Amostra Obrigatória
          </div>
          <div
            className={styles.row_cell}
            style={{ width: grupoSelecionado.value === 5 ? '17%' : '22.5%' }}
          >
            Amostra Opcional
          </div>
          <div
            className={styles.row_cell}
            style={{ width: '17%', display: grupoSelecionado.value === 5 ? 'flex' : 'none' }}
          >
            Medidas Aceitáveis
          </div>
        </div>
        {formularios.map((item, index) => (
          <section
            key={index}
            style={{
              display: item.id_grupo === grupoSelecionado?.value && item.id_grade === tamanhoSelecionado?.value ? 'block' : 'none'
            }}
          >
            <div className={styles.medida_table_row}>
              <div className={styles.row_cell} style={{ width: '10%' }}>
                <Form.Check
                  type={'switch'}
                  style={{ fontSize: '20px' }}
                  onChange={() => onToggleSwitch(index, formularios, setFormularios)}
                  checked={formularios[index].switch}
                  disabled={formularios[index].cannot_switch}
                />
              </div>
              <div
                className={styles.row_cell}
                style={{ width: '5%', display: grupoSelecionado.value === 5 ? 'flex' : 'none' }}
              >
                {item.indice}
              </div>
              <div
                className={styles.row_cell}
                style={{ justifyContent: 'left', width: grupoSelecionado.value === 5 ? '17%' : '22.5%' }}
              >
                {item.descricao_medida}
              </div>
              <div
                className={styles.row_cell}
                style={{ width: grupoSelecionado.value === 5 ? '17%' : '22.5%' }}
              >
                <Form.Control
                  type="text"
                  placeholder={'0.00'}
                  value={formularios[index].piloto}
                  onChange={e => onAtualizarPiloto(index, e.target.value, formularios, setFormularios)}
                  style={{ height: '30px' }}
                  disabled={
                    !formularios[index].switch ||
                    (!possuiPecaPiloto && !referenciaSelecionada.possui_peca_piloto)
                  }
                />
              </div>
              <div
                className={styles.row_cell}
                style={{ width: grupoSelecionado.value === 5 ? '17%' : '22.5%' }}
              >
                <Form.Control
                  type="text"
                  placeholder={'0.00'}
                  value={formularios[index].amostra_obrigatoria}
                  onChange={e => handleValueMask(index, 'amostra_obrigatoria', e.target.value)}
                  style={{ height: '30px' }}
                  disabled={!formularios[index].switch}
                />
              </div>
              <div
                className={styles.row_cell}
                style={{ width: grupoSelecionado.value === 5 ? '17%' : '22.5%' }}
              >
                <Form.Control
                  type="text"
                  placeholder={'0.00'}
                  value={formularios[index].amostra_opcional}
                  onChange={e => handleValueMask(index, 'amostra_opcional', e.target.value)}
                  style={{ height: '30px' }}
                  disabled={!formularios[index].switch}
                />
              </div>
              <div
                className={styles.row_cell}
                style={{ width: '17%', display: grupoSelecionado.value === 5 ? 'flex' : 'none' }}
              >
                <div
                  className={styles.medida_aceitavel}
                  style={{ backgroundColor: formularios[index].medida_aceitavel ? '#B4E38099' : '#ff6c6c99' }}
                >
                  {formularios[index].medida_aceitavel ? 'Sim' : 'Não'}
                </div>
              </div>
            </div>
            {index < formularios.length - 1 && <div className={styles.separator} />}
          </section>
        ))}
      </div>
    </>
  );
}

export default MedidasForm;
